<template>
  <header>
    <v-app-bar relative color="orange lighten-1" height="100" >
      <v-app-bar-title>
        <v-img
          :src="require('@/assets/img/logo_innova_mozzo.png')"
          max-height="90"
          max-width="90"
          to="/"
        />
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <div v-if="this.$vuetify.breakpoint.mdAndUp">
        <v-btn text class="ma-3" to="/"> Home </v-btn>
        <v-btn text class="ma-3" to="/programma"> Programma </v-btn>
        <v-btn text class="ma-3" to="/candidato_sindaco">
          Candidato sindaco
        </v-btn>
        <v-btn text class="ma-3" to="/candidati_consiglieri">
          Candidati consiglieri
        </v-btn>
        <v-btn text class="ma-3" to="/eventi"> Eventi </v-btn>
      </div>
      <div v-else>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute app temporary>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6"> MENU </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list>
        <v-list-item-group color="orange lighten-1">
          <v-list-item link to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/programma">
            <v-list-item-icon>
              <v-icon>mdi-note</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Programma</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/candidato_sindaco">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Candidato sindaco</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/candidati_consiglieri">
            <v-list-item-icon>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Candidati consiglieri</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/eventi">
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Eventi</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </header>
</template>

<script>
export default {
  data: () => ({
    drawer: false,
  }),
};
</script>
